
import Container from '@mui/material/Container';
import QRCode from 'qrcode'
import CustomContainer from '../components/CustomContainer';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import Typography from '@mui/material/Typography';
import { useRef , useContext } from "react"
import DashboardContext from '../context/DashboardContext';
import { useEffect } from 'react';
export function Qrcode(){
    const canvasRef = useRef();
    const {qrcodeLink } = useContext(DashboardContext);
    useEffect(()=>{
       QRCode.toCanvas(canvasRef.current , qrcodeLink ,{width:500}, (error)=>{
        console.log(error)
       })
    },[])
    return(
         <Container>
        <CustomContainer
          style={{ padding: "32px 48px" }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minWidth: 1100,
          }}
        >

          { /* TÍTULO DA PÁGINA */}
          <Typography
            color="primary"
            component="h2"
            mb={4}
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
            variant="h4"
          >
            <QrCode2Icon fontSize="md" sx={{ mr: 1 }} />
            QrCode
          </Typography>
          <div style={{display:'flex' , justifyContent:'center'}}>
          <canvas ref={canvasRef}  id="canvas"></canvas>
          </div>
        </CustomContainer>
        </Container>
    )
}